"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptions = getOptions;

function getOptions() {
  var isPassiveSupported = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (isPassiveSupported) {
    return {
      passive: false
    };
  }

  return {};
}


//////////////////
// WEBPACK FOOTER
// ./~/vanilla-swipe/lib/utils/getOptions.js
// module id = 95
// module chunks = 0